// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table .select-row[data-v-4d3707c4]{background:#f0f9eb}.tip[data-v-4d3707c4]{margin-left:20px;color:#606166}", ""]);
// Exports
module.exports = exports;
